import React, { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import ContributionItem from './contributionItem'
import Button from '../../ui/button'

import { Profile, ProfileContribution } from '../../../store/commonTypes'
import { ContributionType } from '../../../store/contributions/contributionsTypings'

import paths from '../../../paths'
import isEmpty from 'lodash/isEmpty'
import { switchOpenedFromProfile } from '../../../store/contributions/contributionsSlice'
import { useTranslation } from 'react-i18next'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import s from './materialPreview.module.sass'
import ButtonLink from '../../ui/buttonLink'
import { RootState } from '../../../store/rootReducer'

interface Props {
    user: Profile
    self?: boolean
    contributions: ProfileContribution[] | ContributionType[]
    direction?: string
    contributionsTotal: number
}

const ContributionsPreview = ({ user, self, contributions, contributionsTotal }: Props) => {
    const [t] = useTranslation()
    const history = useHistory()
    const dispatch = useDispatch()

    const emptyContributions = isEmpty(contributions)
    const isAgeVerified = useSelector((state: RootState) => state.common.isAgeVerified)

    return (
        <div className={s['materialsPreview']}>
            <div className={s['materialsPreview__row']}>
                <div className={s['materialsPreview__row']}>
                    <div className={s['materialsPreview__title']}>
                        {self ? t('My contributions') : t('Contributions')}
                    </div>
                    <div className={s['materialsPreview__counter']}>{!emptyContributions && contributionsTotal}</div>
                </div>
                {self && (
                    <Button
                        small
                        label={t('Upload contributions')}
                        onClick={() => history.push(createLocalizedPath(paths.submitContribution.path))}
                    />
                )}
            </div>
            {emptyContributions ? (
                self ? (
                    <div className={s['materialsPreview__emptyPlaceholder']}>
                        <div className={s['header']}>{t('You don&apos;t have any contributions')}</div>
                        {/*<div className={s['description']}>{t('But you always can upload some')}</div>*/}
                        {/*<Button*/}
                        {/*    label={t('Upload contributions')}*/}
                        {/*    secondary*/}
                        {/*    onClick={() => history.push(createLocalizedPath(paths.submitContribution.path))}*/}
                        {/*/>*/}
                    </div>
                ) : (
                    <div className={s['materialsPreview__emptyPlaceholder']}>
                        <div className={s['header']}>
                            {user.nick}
                            {t(' doesn&apos;t have any contributions')}
                        </div>
                    </div>
                )
            ) : (
                <div
                    className={s['materialsPreview__list']}
                    onClick={() => dispatch(switchOpenedFromProfile('profile'))}
                >
                    {contributions.map((contribution) => (
                        <ContributionItem
                            contribution={contribution}
                            key={contribution.id}
                            isAgeVerified={isAgeVerified}
                        />
                    ))}
                </div>
            )}
            {!emptyContributions && (
                <ButtonLink
                    secondary
                    label={self ? t('All my contributions') : t('All contributions')}
                    linkUrl={
                        self
                            ? createLocalizedPath(paths.myContributions.path)
                            : createLocalizedPath(paths.profileContributions.toPath({ nick: user.nick }))
                    }
                />
            )}
        </div>
    )
}

export default memo(ContributionsPreview)
